import React, { useEffect, useMemo, useRef, useState } from 'react'

import { marketplaceText } from './marketplaceCopy'
import './marketplace.css'

export const NFT_MARKETPLACE_CREATE_URL =
    process.env.REACT_APP_NFT_MARKETPLACE_CREATE_URL ||
    'https://fatsale.org/#/nft/marketplace/create'

function redirectTo(url) {
    window.location.replace(url)
}

function detectLanguage(language) {
    if (language) return language
    const savedLanguage = window.localStorage?.getItem('i18nextLng')
    return savedLanguage || window.navigator?.language || 'en'
}

export default function MarketplaceLanding({
    countdownSeconds = 10,
    language,
    onRedirect = redirectTo,
}) {
    const totalSeconds = Math.max(1, Math.floor(Number(countdownSeconds) || 10))
    const [remainingSeconds, setRemainingSeconds] = useState(totalSeconds)
    const redirectedRef = useRef(false)
    const activeLanguage = detectLanguage(language)
    const progress = Math.max(0, Math.min(100, (remainingSeconds / totalSeconds) * 100))
    const t = useMemo(
        () => (key, values) => marketplaceText(activeLanguage, key, values),
        [activeLanguage]
    )

    useEffect(() => {
        setRemainingSeconds(totalSeconds)
        redirectedRef.current = false
        const deadline = Date.now() + totalSeconds * 1000
        const timer = window.setInterval(() => {
            const nextValue = Math.max(0, Math.ceil((deadline - Date.now()) / 1000))
            setRemainingSeconds(nextValue)
            if (nextValue <= 0 && !redirectedRef.current) {
                redirectedRef.current = true
                window.clearInterval(timer)
                onRedirect(NFT_MARKETPLACE_CREATE_URL)
            }
        }, 1000)

        return () => window.clearInterval(timer)
    }, [onRedirect, totalSeconds])

    return (
        <main className="market-entry">
            <header className="market-entry__header">
                <span className="market-entry__brand-mark" aria-hidden="true">
                    <i className="fa fa-cube" />
                </span>
                <span className="market-entry__brand-copy">
                    <strong>FatSale</strong>
                    <small>{t('marketplace')}</small>
                </span>
            </header>

            <section className="market-entry__content" aria-labelledby="market-entry-title">
                <p className="market-entry__eyebrow">{t('landingEyebrow')}</p>
                <h1 id="market-entry-title">{t('landingTitle')}</h1>
                <p className="market-entry__description">{t('landingDescription')}</p>

                <div className="market-entry__countdown" aria-live="polite">
                    <strong data-testid="marketplace-landing-countdown">{remainingSeconds}</strong>
                    <div>
                        <span>{t('landingCountdownLabel')}</span>
                        <div className="market-entry__progress" aria-hidden="true">
                            <span style={{ width: `${progress}%` }} />
                        </div>
                    </div>
                </div>

                <a className="market-entry__action" href={NFT_MARKETPLACE_CREATE_URL}>
                    <i className="fa fa-plus" aria-hidden="true" />
                    <span>{t('landingCreateAction')}</span>
                    <i className="fa fa-arrow-right" aria-hidden="true" />
                </a>
            </section>

            <footer className="market-entry__footer">
                <span>FatSale</span>
                <span aria-hidden="true">/</span>
                <span>{t('marketplace')}</span>
            </footer>
        </main>
    )
}
